import PropTypes from "prop-types";

export const AuthLayout = ({ children }) => {
  return (
    <div className="h-screen w-screen bg-main-layout">
      <div className="flex justify-center items-center h-screen ">
        <div className="grid w-1/4">{children}</div>
      </div>
    </div>
  );
};

AuthLayout.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
};
